module.exports = __webpack_public_path__ + "img/四川天府新区万安幼儿园.9fbf3171.jpg";